/**
 * The initial UID prefixer is the top level of any UID prefix tree. `SUI` stands for StormUI
 * @return {string} the string that will prefix all UIDs
 */
function initialUIDPrefixer(suffix: string) {
  return `${suffix ? `${suffix}` : ''}`;
}

export default initialUIDPrefixer;
